import gql from 'graphql-tag';

export const GET_SWITCH_PROGRAM_DIALOG_DATA = gql`
query($id: String!) {
    central(id: $id) {
      name
      from
      to
      project {
        name
      }
      crosssections {
        name
        kilometer
        lanes_count
        ssts {
          id
          name
          position
        }
        devices {
          id
          name
          device_type
          position
          ... on Sign {
            has_blinking_lights
          }
        }
        passive_components {
          name
          passive_component_type
          position
        }
      }
    }
}
`;

export const GET_CLUSTER_DATA = gql`
query($id: String!) {
  cluster(id: $id) {
    cluster_state {
      operating_mode
      brightness
      state
      timestamp
    }
    cluster_command {
      operating_mode
      brightness
      timestamp
    }
  }
}
`;

export const UPDATE_BRIGHTNESS_COMMAND = gql`
  mutation ChangeBrightness($id: String!, $brightness: Int!, $cause: String!, $initiator: String!) {
    changeBrightness(id: $id, brightness: $brightness, cause: $cause, initiator: $initiator)
  }
`;

export const UPDATE_OPERATING_MODE_COMMAND = gql`
  mutation ChangeOperatingMode($id: String!, $operating_mode: Int!, $cause: String!, $initiator: String!) {
    changeOperatingMode(id: $id, operating_mode: $operating_mode, cause: $cause, initiator: $initiator)
  }
`;

export const SWITCH_PROGRAMS = gql`
  mutation SwitchPrograms($programs: [SwitchProgramInput!], $cause: String!, $initiator: String!) {
    switchPrograms(programs: $programs, cause: $cause, initiator: $initiator)
  }
`;

export const GET_SIGN_STATE = gql`
query($id: String!) {
  device(id: $id) {
    ... on Sign {
      sp_image_content
      sign_state {
        program
        program_state
        error_state
        timestamp
      }
      sign_command {
        program
        program_state
        timestamp
      }
      blinking_lights {
        sp_image_content
        blinking_lights_state {
          program
          program_state
          error_state
          timestamp
        }
        blinking_lights_command {
          program
          program_state
          timestamp
        }
      }
    }
  }
}
`;

export const GET_BLINKER_SPECIAL_CONTENT = gql`
query($id: String!) {
  device(id: $id) {
    ... on BlinkingLights {
      sp_image_content
      blinking_lights_command {
        program
        program_state
        timestamp
      }
    }
  }
}
`;

export const GET_SIGN_IMAGE_CONTENTS= gql`
query($id: String!) {
  device(id: $id) {
    ... on Sign {
      image_contents
      sp_image_content
      sign_command {
        program
        program_state
        timestamp
      }
    }
  }
}
`;

export const GET_CROSSSECTION_DATA = gql`
query($id: String!) {
    crosssection(id: $id) {
      traffic_situation {
        trafficSituation
        timestamp
      }
      traffic_data {
        qKfzG
        qLkwG
        qPkwG
        vKfzG
        vLkwG
        vPkwG
        timestamp
      }
    }
}
`;

export const GET_SST_DATA = gql`
query($id: String!) {
  sst(id: $id) {
    solar_controller_data {
      monitoring_error
      deep_discharge_protection_warn_triggered
      deep_discharge_protection_triggered
      over_voltage_protection_triggered
      charge_current
      array_current
      battery_terminal_voltage
      array_voltage
      load_voltage
      battery_current
      load_current
      battery_sense_voltage
      battery_voltage_slow_filter
      battery_current_slow_filter
      timestamp
    }
    mobile_router_data {
      monitoring_error
      mobile_provider
      signal_strength
      cell_identity
      location_area_code
      location_area_id
      mobile_service_type
      registration_state
      timestamp
    }
    fuse_3 {
      released
      timestamp 
    }
    fuse_4 {
      released
      timestamp 
    }
    door_contact {
      open
      timestamp
    }
    gps_data {
      longitude
      latitude
      timestamp
    }
    temperature_data_cabinet {
      temperature
      timestamp
    }
    temperature_data_board {
      temperature
      timestamp
    }
  }
}
`;